import type { TOC } from '@ember/component/template-only';
import GeneralDayDetailDayDetail from 'lumen/components/general/day-detail/day-detail';
import type HotelRatesDetailController from 'lumen/controllers/hotel/rates/detail';

interface HotelRatesDetailSignature {
  Args: {
    controller: HotelRatesDetailController;
    model: unknown;
  };
}
<template>
  <GeneralDayDetailDayDetail
    @activeCompset={{@controller.rates.hotelAndMarketService.activeCompset}}
    @changeDay={{@controller.changeDay}}
    @currentHotel={{@controller.hotel}}
    {{! @glint-expect-error: Incorrect type }}
    @date={{@controller.date}}
    @hasOtbSelfServiceEntryPoint={{true}}
    @isBestFlex={{@controller.isBestFlex}}
    {{! @glint-expect-error: Incorrect type }}
    @isRedirected={{true}}
    @model={{@controller.model}}
    @offset={{@controller.offset}}
    @otaId={{@controller.otaId}}
    @ratesParams={{@controller.ratesParams}}
    @redirect={{@controller.redirect}}
    @selectedOTA={{@controller.selectedOTA}}
    @type={{@controller.type}}
    @updateOffset={{@controller.updateOffset}}
    @updateType={{@controller.updateType}}
  />
</template> satisfies TOC<HotelRatesDetailSignature>;
